// extracted by mini-css-extract-plugin
export default {"centerAbsolute":"style-module--centerAbsolute---FmOt"};